module.exports = __webpack_public_path__ + "static/media/jumping-student.31d08e07.svg";